export const isMac = () => {
    return /Mac|iPod|iPhone|iPad/.test(navigator.platform);
};

export const isIOS = () => {
    return /iPhone|iPad/.test(navigator.platform);
};

export const isAndroid = () => {
    return /Android/.test(navigator.userAgent);
};

export const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
    );
};
